import Api, {
  baseURL,
  requestOptionsDELETE,
  requestOptionsGET,
  requestOptionsPOSTWithArrayBody,
  requestOptionsPOSTForFiles,
  requestOptionsPUTWithBody
} from '../api';
import newFetch from '../utils/newFetch';
import { UrlMaker } from '@/utils/urlParamsMaker';

const getAditionalsReceivableParams = (params, baseUrl) => {
  const { pageNumber, pageSize, initialDate, endDate, senderId, isDiscount, numberCte, linkedInvoice } = params;

  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('PageNumber', pageNumber);
  urlMaker.addKeyAndString('PageSize', pageSize);
  urlMaker.addKeyAndString('CreatedAtStart', initialDate);
  urlMaker.addKeyAndString('CreatedAtEnd', endDate);
  urlMaker.addKeyAndString('SenderId', senderId);
  urlMaker.addKeyAndBoolean('IsDiscount', isDiscount);
  urlMaker.addKeyAndArray('NumberCte', numberCte);
  urlMaker.addKeyAndBoolean('LinkedInvoice', linkedInvoice);

  return urlMaker.getURL();
};

const getAccessKeyCte = (params, baseUrl) => {
  const { senderId, accessKeyCte } = params;
  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('SenderId', senderId);
  urlMaker.addKeyAndString('AccessKeyCte', accessKeyCte);

  return urlMaker.getURL();
};

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchAditionalsReceivable(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getAditionalsReceivableParams(params, Api.getAditionalsReceivable),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getSenders() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSenders, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  validateAccessKeyCte(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getAccessKeyCte(params, Api.validateAccessKeyCte),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  createAditionals(_, payload) {
    let aditionalsToCreate = payload.map((aditional) => {
      const { isDiscount, price, additionalDate, accessKeyCte, observation, documentImportXml } = aditional;
      const senderId = aditional.sender.id;
      const justificationId = aditional.justification.id;
      return {
        senderId,
        isDiscount,
        price,
        justificationId,
        additionalDate,
        accessKeyCte,
        observation,
        documentImportXml
      };
    });
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createAditionalsReceivable,
        requestOptionsPOSTWithArrayBody(localStorage.getItem('accessToken'), aditionalsToCreate)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  editAditional(_, payload) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.editAditionalReceivable,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), payload)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  deleteAditional(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteAditionalReceivable + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  async exportAditionalSheet(_, params = { pageSize: 1000 }) {
    const obj = requestOptionsPOSTForFiles(localStorage.getItem('accessToken'));
    const URL = baseURL + getAditionalsReceivableParams(params, Api.exportAditionalReceivable);
    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        const fileName = response.headers.get('file-name');
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.error(error);
    }
  },

  async downloadXmlAditional(_, id) {
    const obj = requestOptionsPOSTForFiles(localStorage.getItem('accessToken'));
    const URL = baseURL + Api.downloadXmlAditionalReceivable + id;
    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        const fileName = response.headers.get('file-name');
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.error(error);
    }
  },

  deleteXmlAditional(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteXmlAditionalReceivable + id,
        requestOptionsDELETE(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
